export default __webpack_public_path__ + "static/media/js.ca691704.png";